module.exports = __webpack_public_path__ + "img/excel.fa6a68c8.svg";